/* istanbul ignore file */

import { closestCenter, DndContext, PointerSensor, useSensor, useSensors } from '@dnd-kit/core'
import { SortableContext, verticalListSortingStrategy } from '@dnd-kit/sortable'

import SortableTemplateItem from './SortableTemplateItem'

const SortableTemplateList = ({
  templates,
  onToggleTemplate,
  onEdit,
  onDelete,
  onDuplicate,
  disabled,
  dragging,
  onSortEnd,
  onSortStart,
}) => {
  const sensors = useSensors(useSensor(PointerSensor))

  if (templates.length === 0) return null

  return (
    <DndContext sensors={sensors} collisionDetection={closestCenter} onDragEnd={onSortEnd} onDragStart={onSortStart}>
      <SortableContext items={templates} strategy={verticalListSortingStrategy}>
        <div>
          {templates.map((template, index) => (
            <SortableTemplateItem
              key={template.id}
              data={template}
              label={template.name}
              description={template.description}
              enabled={template.is_enabled}
              templateId={template.id}
              internalId={template.internal_id}
              onToggleTemplate={onToggleTemplate}
              onEdit={() => onEdit(template)}
              onDelete={() => onDelete(template.id)}
              onDuplicate={() => onDuplicate(template.id)}
              disabled={disabled}
              hasDisabledTriggers={template.disabled_triggers?.length > 0}
              index={index}
              position={index}
              dragging={dragging}
            />
          ))}
        </div>
      </SortableContext>
    </DndContext>
  )
}

export default SortableTemplateList
